<template>
  <div :style="wrapStyle">
    <button :style="{ ...wrapStyle, ...bgImageStyle }" @click="share"></button>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, common } from '@tencent/ceiba-base-components';

export default {
  name: 'CBbShareButton',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'bb-share-button-',
    };
  },
  computed: {
    wrapStyle() {
      return {
        ...this.styles.base,
      };
    },
    // 按钮背景图
    bgImageStyle() {
      return {
        backgroundImage: `url(${this.configurationData.bgImage
          || 'https://bb.img.qq.com/bbcdn/cf/a20211022reward/img/share-btn.f0036439.png'
          })`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        left: 0,
        top: 0,
      };
    },
    isApp() {
      return this.$ast.isAPP();
    },
    callBackFlowId() {
      return this.configurationData.callBackFlowId || 0;
    },
    showSystemShareButton() {
      return !!this.configurationData.systemButton;
    },
    changeTitleButton() {
      return !!this.configurationData.changeTitleButton;
    },
  },
  async mounted() {
    console.log('configurationData=', this.configurationData);
    window.share = () => {
      this.share();
    };
    await this.initialize();
  },
  methods: {
    async initialize() {
      this.showSystemShareButton && this.showButton();
      if (!this.$ast.isAPP() && this.changeTitleButton && common.tool.getQueryparams('inviteName')) {
        console.log('share_title_change', common.tool.getQueryparams('inviteName'));
        document.getElementsByTagName("title")[0].innerText = `来自${decodeURIComponent(common.tool.getQueryparams('inviteName'))}的分享 D助限时充值抽大奖`;
      }
    },
    share() {
      if (!this.$ast.isAPP()) {
        console.log('configurationData=this.isAPP', this.$ast.isAPP());
        this.$ast.gotoAPP();
        return;
      }
      if (
        typeof window.GameHelper !== 'undefined'
        && typeof window.GameHelper.shareWebPageWithFuntion !== 'undefined'
      ) {
        const title = this.shareConfig.title || this.configurationData.title;
        const desc = this.shareConfig.desc || this.configurationData.desc;
        const icon = this.shareConfig.icon || this.configurationData.icon;
        let url = this.shareConfig.link
          || this.configurationData.shareUrl
          || window.location.href;
        // 当打开的活动url上携带了via,via_source,trace_id参数时，透传当前活动的via,via_source,trace_id到分享链接上
        url = common.tool.passThroughUrlParam(url, ['via', 'trace_id', 'via_source']);
        const type = this.configurationData.shareType || '1,2,3,4,5,8';
        console.log('configurationData.shareDialog', this.configurationData.shareDialog);
        if (this.configurationData.shareDialog) {
          setTimeout(() => {
            this.$alert(this.configurationData.shareDialog);
          }, 1800);
        }
        window.GameHelper.shareWebPageWithFuntion(
          title,
          desc,
          icon,
          url,
          type,
          0,
        );
        this.callBack();
      } else {
        this.$alert('分享失败');
      }
    },
    // 分享回调
    async callBack() {
      console.log(
        'run  doShare callback and this.callBackFlowId = ',
        this.callBackFlowId,
      );
      if (this.callBackFlowId > 0) {
        const response = await this.flowRequest({
          flowId: this.callBackFlowId,
          params: {
            role: this.roleInfo,
          },
        });
        console.log('share callback ', this.callBackFlowId, response);
        this.refreshQua(); // 刷新礼包
      }
    },
    showButton() {
      if (/iphone|ipad|ipod|ios/.test(navigator.userAgent.toLowerCase())) {
        setTimeout(() => {
          if (
            typeof window.GameHelper !== 'undefined'
            && typeof window.GameHelper.showFunctionButton !== 'undefined'
          ) {
            window.GameHelper.showFunctionButton('分享', 'javascript:window.share();');
          }
        }, 1800);
      } else {
        if (
          typeof window.GameHelper !== 'undefined'
          && typeof window.GameHelper.showFunctionButton !== 'undefined'
        ) {
          window.GameHelper.showFunctionButton('分享', 'javascript:window.share();');
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
